import { ComponentFactoryResolver, Injector, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatSlider, MatSliderModule } from '@angular/material/slider';
import { MatInputModule } from '@angular/material/input';

import { SgContentSliderComponent } from './content-slider/content-slider.component';

@NgModule({
  imports: [CommonModule, MatSliderModule, MatInputModule],
  declarations: [SgContentSliderComponent],
  exports: [SgContentSliderComponent],
})
export class SgContentSliderModule {
  constructor(cf: ComponentFactoryResolver, injector: Injector) {
    // this is a workaround to ensure CSS from mat slider is loaded, otherwise it is omitted.
    cf.resolveComponentFactory(MatSlider).create(injector);
  }
}
